import React from 'react';
import './assetStatus.css';
import ProgressBar from '../progressBar/ProgressBar';

import MovingMarker from './img/moving_v2.svg';
import MovementDetectedMarker from './img/movement_detected.svg';
import StopMarker from './img/stop_v2.svg';
import IdleMarker from './img/idle_normal_v2.svg';
import IdleExcessiveMarker from './img/idle_excessive_v2.svg';
import IdleExcusableMarker from './img/idle_excusable_v2.svg';
import InTowMarker from './img/intow_v2.svg';
import StandbyEVMarker from './img/standby_ev.svg';
import StandbyHybridMarker from './img/standby_hybrid.svg';
import CrashMarker from './img/crash.svg';

const STATUS_ROWS = [
    { label: 'Moving', icon: MovingMarker, inference: 200 },
    { label: 'Movement Detected', icon: MovementDetectedMarker, inference: 150 },
    { label: 'Stop', icon: StopMarker, inference: 100 },
    { label: 'Idle', icon: IdleMarker, inference: 400 },
    { label: 'Excessive Idle', icon: IdleExcessiveMarker, inference: 450 },
    { label: 'Excusable Idle', icon: IdleExcusableMarker, inference: 460 },
    { label: 'Towing', icon: InTowMarker, inference: 300 },
    { label: 'EV Standby', icon: StandbyEVMarker, inference: 800 },
    { label: 'Hybrid Standby', icon: StandbyHybridMarker, inference: 850 },
    { label: 'Crash Event', icon: CrashMarker, inference: 700 },
];

const AssetStatus = (props) => {
    const {
        assetList,
    } = props;

    const list = Array.isArray(assetList) ? assetList : [];
    const total = list.length;

    return (
        <div className="assetStatus-rows">
            <div className="assetStatus-count">
                {list.length}
            </div>
            <div className="assetStatus-grid">
                {STATUS_ROWS.map(({ label, icon, inference }) => {
                    const count = list.filter((d) => d.motionInference === inference).length;
                    return (
                        <div key={label} className="assetStatus-inMotion">
                            <img loading="lazy" src={icon} alt="" />
                            <div className="assetStatus-inMotion-progress">
                                <div className="assetStatus">
                                    {label}
                                </div>
                                <ProgressBar value={count} max={total} />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default AssetStatus;
